





































































import { Component, Prop, Ref, Vue, Watch } from "vue-property-decorator";
import moment from "moment";

@Component({
  components: {}
})
export default class TimeStamp extends Vue {
  @Prop() waktu!: string;
  @Prop() maxDate!: string;
  @Prop() minDate!: string;
  menu2 = false;
  tglShow = false;
  tglIsi = moment().format("YYYY-MM-DD");
  time = moment().format("HH:mm:ss");

  get tglIsiFormattedMomentjs() {
    return this.tglIsi ? moment(this.tglIsi).format("DD MMMM YYYY") : "";
  }

  get timeRender() {
    return this.time ? this.time.substring(0, 5) : "";
  }

  @Watch("tglIsi")
  changeTgl() {
    // console.log("tgl ganti", this.tglIsi + " " + this.time);
    // this.tglIsi = this.waktu.substr(0, 10);
    this.$emit("tanggal", this.tglIsi + " " + this.time);
  }

  @Watch("time")
  changeJam() {
    // console.log("time ganti", this.tglIsi + " " + this.time);
    // this.time = this.waktu.substr(11, 8);
    this.$emit("tanggal", this.tglIsi + " " + this.time);
  }

  @Watch("waktu")
  changeWaktu() {
    // console.log("change waktu", this.tglIsi + " " + this.time);
    this.tglIsi = this.waktu.substr(0, 10);
    this.time = this.waktu.substr(11, 8);
    this.$emit("tanggal", this.tglIsi + " " + this.time);
  }
}
